/* React */
import React from "react";

/* Ionic */
import { calendar } from "ionicons/icons";

/* Constants */
import { DATE_RESTRICTION } from "src/shared/constants/custom-cohorts/DateRestriction";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";
import SegmentButton from "src/components/shared/buttons/segment-button/SegmentButton";

/* Stylesheet */
import styles from "./DateRestriction.module.scss";

/* Interfaces */
import { DateRestrictionType } from "src/shared/interfaces/custom-cohorts/DateRestriction";
import {
  Keys,
  BasicProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

interface DateRestrictionProps {
  dateRestriction: DateRestrictionType;
  disabled: boolean;
  handleUpdate: <K extends keyof BasicProps>(
    key: K,
    data?: {
      value: BasicProps[K];
    }
  ) => void;
}

const DateRestriction: React.FC<DateRestrictionProps> = ({
  dateRestriction,
  disabled,
  handleUpdate,
}) => {
  const restriction: DateRestrictionType[] =
    DATE_RESTRICTION;

  return (
    <React.Fragment>
      <FilterLabel
        scssProps={{
          margin: "42px 0px 12px 16px",
          color: disabled
            ? "var(--ion-color-text-disabled)"
            : "var(--ion-color-text-primary)",
        }}
        label={"Date restriction"}
      />
      <div className={styles.date_restriction}>
        {restriction.map(
          (item: DateRestrictionType, index: number) => {
            const isSelected = dateRestriction === item;
            return (
              <SegmentButton
                key={index}
                label={item}
                value={isSelected}
                disabled={disabled}
                onClick={() =>
                  handleUpdate(Keys.DATE_RESTRICTION, {
                    value: item,
                  })
                }
              />
            );
          }
        )}
        <SegmentButton
          label={"10/21/2024"}
          value={false}
          icon={calendar}
          disabled={true}
          onClick={() => console.log("Date clicked")}
        />
      </div>
    </React.Fragment>
  );
};

export default DateRestriction;
